import dayjs from "dayjs";

/**
 * Appends localized month names to a quarter months label.
 * e.g. "8-10" -> "8-10 [August - October]" (en) / "8-10 [tháng 8 - tháng 10]" (vi)
 */
export const formatMonthsLabelWithNames = (monthsLabel: string): string => {
  const months = monthsLabel.match(/\d{1,2}/g);
  if (!months || months.length < 2) return monthsLabel;
  const start = parseInt(months[0], 10);
  const end = parseInt(months[months.length - 1], 10);
  if (start < 1 || start > 12 || end < 1 || end > 12) return monthsLabel;
  const startName = dayjs().month(start - 1).format("MMMM");
  const endName = dayjs().month(end - 1).format("MMMM");
  return `${monthsLabel} [${startName} - ${endName}]`;
};
